// extracted by mini-css-extract-plugin
export var backdropBlur = "_m1-0";
export var contentCard = "_m1-5";
export var frame = "_m1-2";
export var image = "_m1-4";
export var imagePane = "_m1-3";
export var modal = "_m1-1";